import React, { useState } from "react";
import {
  TextField,
  Button,
  Box,
  Paper,
  IconButton,
  Chip,
  Typography,
} from "@mui/material";
import CommonAccordion from "../../custom-components/CommonAccordion";
import AddIcon from "@mui/icons-material/Add";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import SendIcon from "@mui/icons-material/Send";
import { ReactComponent as LoadIcon } from "../../../images/loadExampleButton.svg";
import ContentPasteSearchIcon from "@mui/icons-material/ContentPasteSearch";
import ClearIcon from "@mui/icons-material/Clear";
import { ReactComponent as UserStoryIcon } from "../../../images/userStoryIcon.svg";
import { ReactComponent as DocumentIcon } from "../../../images/quick_reference_all.svg";

const References = () => {
  const [oAuth, setOAuth] = useState("");
  const [documentTitle, setDocumentTitle] = useState("");
  const [documents, setDocuments] = useState([]);
  const [approvalNames, setApprovalNames] = useState([]);
  const [audienceEmails, setAudienceEmails] = useState([]);
  const [inputName, setInputName] = useState("");
  const [inputEmail, setInputEmail] = useState("");

  const isFormValid = () =>
    documents.length > 0 &&
    approvalNames.length > 0 &&
    audienceEmails.length > 0;

  const handleAddDocument = (event) => {
    if (!event || !event.target || !event.target.files) {
      console.error("File input event is missing or incorrect.");
      return;
    }

    const files = event.target.files;
    const allowedExtensions = [".doc", ".docx"]; // Allowed file types
    const newDocuments = [];

    if (files.length === 0) {
      alert("No file selected. Please upload a .doc or .docx file.");
      return;
    }

    for (let i = 0; i < files.length; i++) {
      const fileName = files[i].name;
      const fileExtension = fileName
        .substring(fileName.lastIndexOf("."))
        .toLowerCase();

      if (!allowedExtensions.includes(fileExtension)) {
        alert("Invalid file type. Please upload a .doc or .docx file.");
        return;
      }

      newDocuments.push({
        name: fileName, // Full file name
        displayName: fileName, // Display name without extension
      });
    }
    setDocumentTitle(newDocuments[0].displayName);
    // setDocuments(newDocuments);
  };

  const handleUploadDocument = () => {
    // Handle document upload logic here
    if (oAuth.trim() === "") {
      alert("Please enter OAuth 2.0 Flow");
      return;
    }
    if (documentTitle.trim() === "") {
      alert("Please enter document title");
      return;
    }
    // Handle document upload logic here
    setDocuments([...documents, { name: oAuth, displayName: documentTitle }]);
    setOAuth("");
    setDocumentTitle("");
  };

  const handleRemoveDocument = (index) => {
    setDocuments(documents.filter((_, i) => i !== index));
  };

  const handleAddApproval = () => {
    if (inputName.trim() && !approvalNames.includes(inputName)) {
      setApprovalNames([...approvalNames, inputName]);
      setInputName("");
    }
  };

  const handleRemoveApproval = (name) => {
    setApprovalNames(approvalNames.filter((n) => n !== name));
  };

  const handleAddAudience = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Simple email regex validation

    if (
      inputEmail.trim() &&
      emailRegex.test(inputEmail) &&
      !audienceEmails.includes(inputEmail)
    ) {
      setAudienceEmails([...audienceEmails, inputEmail]);
      setInputEmail("");
    } else {
      alert("Please enter a valid email address.");
    }
  };

  const handleRemoveAudience = (email) => {
    setAudienceEmails(audienceEmails.filter((e) => e !== email));
  };


  const handleTypeLoadDemoExample = (e) => {
    e.stopPropagation();
    setOAuth("OAuth 2.0 Flow Example");
    setDocumentTitle("OAuth 2.0 Flow Example");
    setDocuments([
      { name: "OAuth 2.0 Flow Example", displayName: "OAuth 2.0 Flow Example" },
    ]);
    setApprovalNames(["John Doe", "Jane Doe"]);
    setAudienceEmails(["john.doe@gmail.com", "jane.doe@gmail.com"]);  
  }
  return (
    <CommonAccordion
      summary={
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          width="100%"
        >
          <span>References</span>
          <Button
            variant="text"
            startIcon={<LoadIcon />}
            sx={{
              textTransform: "none",
            }}
            onClick={handleTypeLoadDemoExample}
          >
            Load Demo Example
          </Button>
        </Box>
      }
      details={
        <Box sx={{ paddingRight: 4, paddingLeft: 1, mb: 3, mt: 2 }}>
          <Typography
            variant="h6"
            sx={{
              fontFamily: "Manrope",
              fontSize: "16px",
              letterSpacing: "0.25px",
              fontWeight: "600",
              mb: 2,
            }}
          >
            Reference Document
          </Typography>
          <Paper
            sx={{
              backgroundColor: "#49A3FF0F",
              padding: 3,
              borderRadius: 2,
              boxShadow: "none",
              border: "1px solid #E0E0E0",
            }}
          >
            <TextField
              fullWidth
              label="OAuth 2.0 Flow"
              variant="outlined"
              placeholder="Enter OAuth 2.0 Flow"
              sx={{ mb: 2 }}
              value={oAuth}
              onChange={(e) => setOAuth(e.target.value)}
            />
            <label htmlFor="file-upload">
              <Box
                sx={{
                  mt: 1,
                  display: "flex",
                  alignItems: "center",
                  border: "1px dashed #49A3FF",
                  borderRadius: "8px",
                  padding: "12px",
                  cursor: "pointer",
                  width: "95%",
                  backgroundColor: "#49A3FF0F",
                  color: "#000",
                  fontFamily: "Manrope",
                  fontSize: "14px",
                  lineHeight: "20px",
                  letterSpacing: "0px",
                  textAlign: "left",
                  fontWeight: "500",
                  mb: 3,
                  gap: 1,
                }}
              >
                <UserStoryIcon sx={{ mr: 2 }} />
                {documentTitle ? documentTitle : "Upload Document"}
              </Box>
            </label>
            <input
              type="file"
              id="file-upload"
              hidden
              accept=".doc,.docx" // Restricts file picker to only show .doc and .docx files
              onChange={handleAddDocument}
            />
            <Button
              variant="outlined"
              startIcon={<AddIcon />}
              sx={{
                textTransform: "none",
                color: "#49A3FF",
                fontFamily: "Manrope",
                fontSize: "14px",
                borderRadius: "8px",
              }}
              onClick={handleUploadDocument}
            >
              Add Document
            </Button>
          </Paper>
          {documents.length > 0 && (
            <Box sx={{ mt: 3 }}>
              {documents.map((doc, index) => (
                <Paper
                  key={index}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    mb: 1,
                    padding: "8px 12px",
                    borderRadius: "12px",
                    backgroundColor: "#F8FAFC",
                    border: "1px solid #E0E0E0",
                    width: "95%", // Ensures it takes full width
                    maxWidth: "95%", // Prevents excessive stretching
                    overflow: "hidden",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      flexGrow: 1,
                      overflow: "hidden",
                    }}
                  >
                    <Typography
                      sx={{ fontSize: 14, mr: 1, fontFamily: "Manrope" }}
                    >
                      {index + 1}.
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: 14,
                        flexGrow: 1,
                        fontFamily: "Manrope",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: "250px", // Ensures filename truncates
                      }}
                    >
                      {doc.name}
                    </Typography>
                    <DocumentIcon sx={{ color: "#49A3FF", ml: 1 }} />
                    <Typography sx={{ fontSize: 14, ml: 1, color: "#757575" }}>
                      {doc.displayName}
                    </Typography>
                  </Box>
                  <IconButton
                    onClick={() => handleRemoveDocument(index)}
                    sx={{ ml: 1, p: 0, flexShrink: 0 }} // Ensures it does not get pushed out
                  >
                    <RemoveCircleOutlineIcon
                      sx={{ color: "#E24E4E", fontSize: "20px" }}
                    />
                  </IconButton>
                </Paper>
              ))}
            </Box>
          )}

          {/* Approval Section */}
          <Typography
            variant="h6"
            sx={{
              fontFamily: "Manrope",
              fontSize: "16px",
              letterSpacing: "0.25px",
              fontWeight: "600",
              mt: 6,
              mb: 2,
            }}
          >
            Approval
          </Typography>
          <TextField
            fullWidth
            label="Add Name"
            variant="outlined"
            placeholder="Add Name"
            value={inputName}
            onChange={(e) => setInputName(e.target.value)}
            sx={{ mb: 2 }}
            onKeyPress={(e) => e.key === "Enter" && handleAddApproval()}
          />
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
            {approvalNames.map((name, index) => (
              <Chip
                key={index}
                label={name}
                onDelete={() => handleRemoveApproval(name)}
                deleteIcon={
                  <ClearIcon
                    sx={{
                      color: "#666",
                      fontSize: "16px",
                      "&:hover": { color: "#333" },
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleRemoveApproval(name);
                    }}
                  />
                }
                sx={{
                  backgroundColor: "#e8f4fd",
                  color: "#333",
                  "& .MuiChip-deleteIcon": {
                    color: "#999",
                  },
                }}
              />
            ))}
          </Box>

          {/* Intended Audience Section */}
          <Typography
            variant="h6"
            sx={{
              fontFamily: "Manrope",
              fontSize: "16px",
              letterSpacing: "0.25px",
              fontWeight: "600",
              mt: 4,
              mb: 2,
            }}
          >
            Intended Audience
          </Typography>
          <TextField
            fullWidth
            label="Add Email ID"
            variant="outlined"
            placeholder="Add Email ID"
            value={inputEmail}
            onChange={(e) => setInputEmail(e.target.value)}
            sx={{ mb: 2 }}
            onKeyPress={(e) => e.key === "Enter" && handleAddAudience()}
          />
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
            {audienceEmails.map((name, index) => (
              <Chip
                key={index}
                label={name}
                onDelete={() => handleRemoveAudience(name)}
                deleteIcon={
                  <ClearIcon
                    sx={{
                      color: "#666",
                      fontSize: "16px",
                      "&:hover": { color: "#333" },
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleRemoveAudience(name);
                    }}
                  />
                }
                sx={{
                  backgroundColor: "#e8f4fd",
                  color: "#333",
                  "& .MuiChip-deleteIcon": {
                    color: "#999",
                  },
                }}
              />
            ))}
          </Box>
        </Box>
      }
      buttons={[
        {
          label: "Generate Report",
          variant: "contained",
          startIcon: <SendIcon />,
          sx: {
            float: "right",
            textTransform: "none",
            backgroundColor: isFormValid() ? "#49A3FF" : "grey",
            color: "white",
            "&:hover": {
              backgroundColor: isFormValid() ? "#007BFF" : "darkgrey",
            },
          },
          disabled: !isFormValid(),
        },
      ]}
    />
  );
};

export default References;
